<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :title="$t('Home.Tips')"
      :visible.sync="_dialogVisible"
      class="new-dialog dialog-550 new-dialog-tips"
      @close="onCancel"
    >
      <div slot="title">
        <img
          :src="tips2"
          class="new-tips-icon"
          v-if="$route.meta.theme == 'news-theme'"
        />
        <img
          :src="tips3"
          class="new-tips-icon"
          v-else-if="$route.meta.theme == 'sanction-theme'"
        />
        <img :src="tips1" class="new-tips-icon" v-else />
        <div class="center el-dialog__title">{{ $t("Home.Tips") }}</div>
      </div>
      <div class="new-dialog-desc">
        {{ $t("Home.detailconttext") }}
      </div>
      <div slot="footer" class="center new-dialog-footer">
        <!-- <el-button class="cancel new-dialog-footer-btn" @click="onCancel">
          OK
        </el-button> -->
        <el-button class="new-dialog-footer-btn" @click="onConfirm">
          {{ $t("Home.Subscribe") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: { type: Boolean, default: false },
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  data() {
    return {
      tips1: require("@/assets/images/newPage/tipsBlue.png"),
      tips2: require("@/assets/images/newPage/tipsGreen.png"),
      tips3: require("@/assets/images/newPage/tipsOrange.png"),
    };
  },
  methods: {
    onCancel() {
      this._dialogVisible = false;
    },
    onConfirm() {
      this.$router.push({
        path: "/index/addCredit",
      });
    },
  },
};
</script>
<style scoped>
.new-tips-icon {
  display: block;
  width: 80px;
  height: 70px;
  margin: 0 auto 10px auto;
}
.new-dialog-desc {
  font-family: "Arial";
  line-height: 20px;
  font-size: 16px;
  color: #1a2332;
  word-break: break-word;
}
.new-dialog >>> .el-dialog__footer {
  padding-top: 14px;
}
.new-dialog-footer .el-button + .el-button {
  margin-left: 30px;
}
@media (max-width: 1439px) {
  .new-tips-icon {
    width: 55px;
    height: 48px;
    margin: 0 auto 14px auto;
  }
  .new-dialog-desc {
    line-height: 22px;
    font-size: 14px;
  }
  .new-dialog >>> .el-dialog__footer {
    padding-top: 20px;
  }
  .new-dialog-footer .el-button + .el-button {
    margin-left: 20px;
  }
  .new-dialog-desc {
    line-height: 18px;
    font-size: 14px;
  }
}
</style>

<style>
.new-dialog.new-dialog-tips .el-dialog {
  margin-top: 0 !important;
}
.new-dialog.new-dialog-tips .new-dialog-footer-btn span {
  font-family: "Arial";
  font-size: 16px;
}

.new-dialog.new-dialog-tips .el-button:hover {
  color: #ffffff;
  background: #1290c9;
}

@media (max-width: 1439px) {
  .new-dialog.new-dialog-tips .new-dialog-footer-btn span {
    font-size: 14px;
  }
}
</style>
